export const UPDATE_RECOMMENDATION_COUNT = 'recommendation/UPDATE_RECOMMENDATION_COUNT';
export const RESET = 'recommendation/RESET';
export const POPULATE_RECOMMENDATIONS = 'recommendation/POPULATE_RECOMMENDATIONS';
export const SET_SELECTED_STUDY_TEST_RECOMMENDATION = 'recommendation/SET_SELECTED_STUDY_TEST_RECOMMENDATION';
export const SET_SELECTED_RECOMMENDATION = 'recommendation/SET_SELECTED_RECOMMENDATION';



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/recommendation/recommendation.action.const.ts